import React from 'react'

const createElement = element => (config = {}) => React.createElement(element, config)

export default createElement
